import { Mutex } from 'await-semaphore';
import { AuthProxyUrlBuilder } from './AuthProxyUrlBuilder';
import { AuthServiceV2 } from './AuthServiceV2';
/**
 * @deprecated Use v3 instead. This version will be removed ca. August 2022
 */
export var AuthServiceEventV2;
(function (AuthServiceEventV2) {
    AuthServiceEventV2["LOGIN"] = "login";
    AuthServiceEventV2["SAVE_STATE"] = "saveState";
    AuthServiceEventV2["LOGOUT"] = "logout";
})(AuthServiceEventV2 || (AuthServiceEventV2 = {}));
export class AuthServiceProviderV2 {
    constructor(authServiceOptions, sharedState, authServiceProviderV3, localeService, envConfigService, serverRequest, logger) {
        this.authServiceOptions = authServiceOptions;
        this.sharedState = sharedState;
        this.authServiceProviderV3 = authServiceProviderV3;
        this.localeService = localeService;
        this.envConfigService = envConfigService;
        this.serverRequest = serverRequest;
        this.logger = logger;
        this.registeredAuthServices = {};
    }
    /**
     * Creates a new AuthService instance or returns an existing instance for an already registered fag.
     * @param fag FeatureAppGroup to register for
     */
    register(fag) {
        if (!this.authServiceOptions.fagScopeMappings.get(fag)) {
            throw new Error(`Unknown feature app group "${fag}". Please check authService configuration.`);
        }
        if (this.registeredAuthServices[fag]) {
            return this.registeredAuthServices[fag];
        }
        let sharedAuthServiceState = this.sharedState.authServiceState.get(fag);
        if (!sharedAuthServiceState) {
            sharedAuthServiceState = { mutex: new Mutex() };
            this.sharedState.authServiceState.set(fag, sharedAuthServiceState);
        }
        const v3 = this.authServiceProviderV3.register(fag);
        const service = new AuthServiceV2(fag, this.sharedState.eventEmitter, this.authServiceOptions, v3, this.loginAll.bind(this), sharedAuthServiceState, this.getConfig.bind(this), this.serverRequest, this.logger);
        this.registeredAuthServices[fag] = service;
        return service;
    }
    // TODO: login only fags which are not already authenticated? currently each call logs in all fags
    loginAll(prompt, redirectUrl, options) {
        const registeredFags = Array.from(this.sharedState.authServiceState.keys());
        const { language, countryCode } = this.localeService;
        const loginUrl = AuthProxyUrlBuilder.getLoginUrl(this.authServiceOptions, registeredFags, `${language}-${countryCode}`, prompt, redirectUrl, options);
        window.location.assign(loginUrl);
    }
    async getConfig(key = 'forms') {
        const rawConfig = await this.envConfigService.getConfiguration(key);
        return rawConfig;
    }
}
//# sourceMappingURL=AuthServiceProviderV2.js.map